import { render, staticRenderFns } from "./UploadManager.vue?vue&type=template&id=679ffbce&"
import script from "./UploadManager.vue?vue&type=script&lang=js&"
export * from "./UploadManager.vue?vue&type=script&lang=js&"
import style0 from "@/vendor/styles/pages/file-manager.scss?vue&type=style&index=0&lang=scss&"
import style1 from "@/vendor/libs/vue-dropzone/vue-dropzone.scss?vue&type=style&index=1&lang=scss&"
import style2 from "@/vendor/libs/spinkit/spinkit.scss?vue&type=style&index=2&lang=scss&"
import style3 from "./UploadManager.vue?vue&type=style&index=3&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cognatis/api/frontend/foundation/dev/webapp/vue-project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('679ffbce', component.options)
    } else {
      api.reload('679ffbce', component.options)
    }
    module.hot.accept("./UploadManager.vue?vue&type=template&id=679ffbce&", function () {
      api.rerender('679ffbce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/upload/UploadManager.vue"
export default component.exports